import { put, call, getContext } from "redux-saga/effects";

import { deleteDocClaim } from "../../Services/ClaimCashless";

export function* deleteDocSaga(action) {
  const store = yield getContext("store");

  const { payload } = action;
  // console.log(payload);

  try {
    const res = yield call(deleteDocClaim, payload);

    yield put({
      type: "REQ_DELETE_CLAIM_DOC_SUCCESS",
      data: {
        claimId: payload.claimId,
        instanceId: payload.instanceId,
        data: res.data,
      },
    });
  } catch (e) {
    yield put({
      type: "REQ_DELETE_CLAIM_DOC_FAILED",
      errData: { e, claimId: payload.claimId, instanceId: payload.instanceId },
    });
  }
}
